import { render, staticRenderFns } from "./v010_fixed_phrase.vue?vue&type=template&id=3ff4071c&"
import script from "./v010_fixed_phrase.vue?vue&type=script&lang=js&"
export * from "./v010_fixed_phrase.vue?vue&type=script&lang=js&"
import style0 from "./v010_fixed_phrase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports